import Splide from '@splidejs/splide';

(() => {
  const categoryCardsEl = document.querySelectorAll('.js-category-cards');
  if (!categoryCardsEl.length) return;

  categoryCardsEl.forEach((el) => {
    const sourceData = el.querySelectorAll(':scope > ul > li');

    const slider = document.createElement('div');
    slider.classList.add('category-cards', 'splide');
    const track = document.createElement('div');
    track.classList.add('splide__track');
    const list = document.createElement('div');
    list.classList.add('splide__list');
    track.appendChild(list);
    slider.appendChild(track);
    el.insertAdjacentElement('beforebegin', slider);

    sourceData.forEach((item) => {
      const title = item?.querySelector(':scope > a')?.textContent || item?.querySelector('.title')?.textContent;
      const mainLink = item?.querySelector(':scope > a')?.href || item?.querySelector('.link')?.textContent;
      const categories = item?.querySelectorAll(':scope > ul > li:not(.has-image)') || '';
      const description = item?.querySelector('.description')?.textContent || '';
      const image = item?.querySelector('.has-image > a > img')?.src || item?.querySelector('.image')?.textContent;

      const card = document.createElement('div');
      card.classList.add('category-card', 'splide__slide');

      const cardImage = document.createElement('img');
      cardImage.classList.add('category-card__image');
      cardImage.src = image;
      card.appendChild(cardImage);

      const cardContent = document.createElement('div');
      cardContent.classList.add('category-card__content');

      const cardTitle = document.createElement('h3');
      cardTitle.classList.add('category-card__title');
      cardTitle.textContent = title;
      cardContent.appendChild(cardTitle);

      if (categories.length) {
        const cardCategories = document.createElement('ul');
        cardCategories.classList.add('category-card__categories', 'list-custom');
        categories.forEach((category) => {
          cardCategories.appendChild(category);
        });
        cardContent.appendChild(cardCategories);
      }

      if (description) {
        const cardDescription = document.createElement('p');
        cardDescription.classList.add('category-card__description');
        cardDescription.textContent = description;
        cardContent.appendChild(cardDescription);
      }

      const cardButton = document.createElement('a');
      cardButton.classList.add('category-card__button', 'btn-custom', 'secondary');
      cardButton.href = mainLink;
      cardButton.textContent = 'see more';
      cardContent.appendChild(cardButton);

      card.appendChild(cardContent);
      list.appendChild(card);
    });

    const splide = new Splide(slider, {
      type: 'loop',
      perPage: 4,
      perMove: 4,
      gap: 30,
      arrows: true,
      pagination: false,
      padding: {
        left: 0,
        right: 80,
      },
      breakpoints: {
        1300: {
          perPage: 3,
          perMove: 3,
        },
        1024: {
          perPage: 2,
          perMove: 2,
        },
        768: {
          perPage: 1,
          perMove: 1,
          padding: 0,
        },
      },
    });

    splide.mount();
  });
})();
